import React from 'react';

import { FlagsClient } from './create-flags-client';

export const FlagsContext = React.createContext<FlagsClient | null>(null);

type FlagsProviderProps = {
  client: FlagsClient;
  children: React.ReactNode;
};

export const FlagsProvider = ({ client, children }: FlagsProviderProps) => {
  return <FlagsContext.Provider value={client}>{children}</FlagsContext.Provider>;
};
